import { useEffect } from 'react';
import usePrevious from 'Hooks/usePrevious';
import { getModal } from 'Helpers/ModalHelper';

export default function useModalClosedEffect(modalName, onClose, dependencies = []) {
  const { modalName: currModalName } = getModal();
  const prevModalName = usePrevious(currModalName);
  const justClosed = prevModalName === modalName && currModalName !== modalName;

  useEffect(() => {
    if (justClosed) {
      onClose(...dependencies);
    }
  }, [justClosed, ...dependencies]);
}
